import { createNetworkingLayer } from "@mirage-web/networking/layer";

import { queryClient } from "~/lib/query-client";
import { getAuthStore } from "~/modules/auth/auth-store";
import { sessionStorageDef } from "~/modules/auth/credentials";
import { getConfigStore } from "~/stores/config";

async function getAccessToken(): Promise<string | null> {
  return getAuthStore().getAccessToken();
}

export const { createQueryRequestDefinition, createMutationRequestDefinition } =
  createNetworkingLayer({
    getAccessToken,
    getApiHost: (host) => {
      const map = {
        "cap-srv": getConfigStore().env.CAP_SRV_API_URL,
        "cap-code": getConfigStore().env.CAP_CODE_API_URL,
      };

      return map[host];
    },
    queryClient,
    trackRequest: (payload) => {
      if (payload.status === "fail") {
        console.log(payload);
      }
    },
    headers() {
      const session = sessionStorageDef.get();
      const headers = {
        "x-product-id": "internal-oasis",
      };

      if (session) {
        return {
          ...headers,
          "x-oasis-session-id": session.sessionId,
        };
      }

      return headers;
    },
  });
